<template>
  <el-dialog
    :visible.sync="sortDialogVisible"
    width="900px"
    top="5vh"
    custom-class="sort-modules"
    :before-close="handleClose">
    <template slot="title">
      模块设置 <small>你可以对主页模块进行排序设置以及隐藏展示设置</small>
    </template>
    <ul class="list">
      <li class="item active">项目名称<span class="pull-right">操作</span></li>
      <draggable v-model="modulesClone">
          <transition-group>
            <template v-for="(module, index) in modulesClone">
              <template v-if="module.name != 'groups' ? true : module.data.length > 0 ">
                <template v-if="module.is_show == 1">
                  <li class="item drag-item" :key="index">
                    <el-tooltip class="item" effect="dark" content="拖拽排序" placement="top">
                      <i class="iconfont icon--drag"></i>
                    </el-tooltip>
                    {{module.name_cn}}
                    <el-button-group class="pull-right">
                      <el-button type="text" @click.stop="move(index, index - 1)">上移</el-button>
                      <el-button type="text" @click.stop="move(index, index + 1)">下移</el-button>
                      <template v-if="isMobile">
                        <el-button type="text" @click="hideModule(index)">
                          <i class="iconfont icon--show"></i>
                        </el-button>
                      </template>
                      <template v-else>
                        <el-button type="text" @click="hideModule(index)">隐藏</el-button>
                      </template>
                    </el-button-group>
                  </li>
                </template>
                <template v-else>
                  <li class="item active drag-item" :key="index">
                    {{module.name_cn}}
                    <span class="hide-text">
                      （此模块已隐藏）
                    </span>
                    <template v-if="isMobile">
                      <el-button type="text" class="pull-right" @click="showModule(index)">
                        <i class="iconfont icon--hide"></i>
                      </el-button>
                    </template>
                    <template v-else>
                      <el-button type="text" class="pull-right" @click="showModule(index)">显示</el-button>
                    </template>
                  </li>
                </template>
              </template>
            </template>
          </transition-group>
      </draggable>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import draggable from 'vuedraggable'
import $ from 'jquery'
import { MessageBox } from 'mint-ui'
export default {
  props: {
    sortDialogVisible: Boolean,
    modules: Array
  },
  data () {
    return {
      modulesClone: JSON.parse(JSON.stringify(this.modules)),
      isMobile: false
    }
  },
  created () {
    if (document.body.offsetWidth < 500) {
      this.isMobile = true
    }
  },
  methods: {
    handleClose () {
      this.cancel()
    },
    cancel () {
      this.$emit('cancel')
      this.modulesClone = this.modules
    },
    save () {
      this.$emit('update', this.modulesClone)
    },
    hideModule (index) {
      if (this.isMobile) {
        MessageBox.confirm('模块将设为隐藏，将不在主页展示，其他人浏览时不可见。', `确认隐藏「${this.modulesClone[index].name_cn}」模块吗？`).then(action => {
          this.modulesClone[index].is_show = 0
        }).catch(() => {})
        return false
      }
      // 二次确认
      this.$confirm('模块将设为隐藏，将不在主页展示，其他人浏览时不可见。', `确认隐藏「${this.modulesClone[index].name_cn}」模块吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '隐藏成功!'
        })
        this.modulesClone[index].is_show = 0
      }).catch(() => {})
    },
    showModule (index) {
      this.modulesClone[index].is_show = 1
    },
    move (current, target) {
      if (target < 0) {
        this.$message({
          type: 'warning',
          message: '已经到顶部了哟！'
        })
        return false
      }
      if (target >= this.modulesClone.length) {
        this.$message({
          type: 'warning',
          message: '已经到底部了哟!'
        })
        return false
      }
      if (current > target) { // 上移
        $(this.$el).find(`.drag-item:eq(${current})`).blur().addClass('animate up').prev().addClass('animate down')
      } else {
        $(this.$el).find(`.drag-item:eq(${current})`).blur().addClass('animate down').next().addClass('animate up')
      }
      setTimeout(() => {
        const temp = this.modulesClone[target]
        this.$set(this.modulesClone, target, this.modulesClone[current])
        this.$set(this.modulesClone, current, temp)
        if (current > target) { // 上移
          $(this.$el).find(`.drag-item:eq(${current})`).removeClass('animate up').prev().removeClass('animate down')
        } else {
          $(this.$el).find(`.drag-item:eq(${current})`).removeClass('animate down').next().removeClass('animate up')
        }
      }, 300)
    }
  },
  components: {
    draggable
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/pages/Index/SortModules/index.vue